export enum ButtonColors {
	Default = 'rgba(255, 255, 255, 0.05)',
	Select = '#1782FF',
	Select2 = '#2D70DA',
	Cancel = '#C71E1E',
	Help = '#FABE2C',
	Buy = '#1F8034',
	Black1 = '#111314',
	Gold = 'rgba(255, 181, 0, 0.1)',
	LightGreen = '#1AB248',
	Cancel25 = 'rgba(199, 30, 30, 0.25)',
	Cancel75 = 'rgba(199, 30, 30, 0.75)',
	LightBlue = '#3491E9',
	Gold2 = '#FFBB00',
}

export const buttonTextColors: Record<ButtonColors, string> = {
	[ButtonColors.Default]: '#ffffff',
	[ButtonColors.Select]: '#ffffff',
	[ButtonColors.Select2]: '#ffffff',
	[ButtonColors.Cancel]: '#ffffff',
	[ButtonColors.Help]: '#000000',
	[ButtonColors.Buy]: '#ffffff',
	[ButtonColors.Black1]: '#ffffff',
	[ButtonColors.Gold]: '#ffffff',
	[ButtonColors.LightGreen]: '#ffffff',
	[ButtonColors.Cancel25]: '#C71E1E',
	[ButtonColors.Cancel75]: '#C71E1E',
	[ButtonColors.LightBlue]: '#ffffff',
	[ButtonColors.Gold2]: '#000000',
};

export const buttonBorderColors: Record<ButtonColors, string> = {
	[ButtonColors.Default]: 'rgba(255, 255, 255, 0.1)',
	[ButtonColors.Select]: 'transparent',
	[ButtonColors.Select2]: 'transparent',
	[ButtonColors.Cancel]: 'transparent',
	[ButtonColors.Help]: 'transparent',
	[ButtonColors.Buy]: 'transparent',
	[ButtonColors.Black1]: 'rgba(255, 255, 255, 0.1)',
	[ButtonColors.Gold]: 'rgba(255, 181, 0, 0.25)',
	[ButtonColors.LightGreen]: 'transparent',
	[ButtonColors.Cancel25]: 'rgba(199, 30, 30, 0.5)',
	[ButtonColors.Cancel75]: '#C71E1E',
	[ButtonColors.LightBlue]: 'transparent',
	[ButtonColors.Gold2]: 'transparent',
};

export enum ButtonHeight {
	Height20 = '20',
	Height30 = '30',
	Height40 = '40',
	Height50 = '50',
	Height60 = '60',
}

export const buttonFontSize = {
	[ButtonHeight.Height20]: 12,
	[ButtonHeight.Height30]: 14,
	[ButtonHeight.Height40]: 16,
	[ButtonHeight.Height50]: 18,
	[ButtonHeight.Height60]: 20,
};

export const buttonPadding = {
	[ButtonHeight.Height20]: 6.5,
	[ButtonHeight.Height30]: 14,
	[ButtonHeight.Height40]: 11,
	[ButtonHeight.Height50]: 18,
	[ButtonHeight.Height60]: 37.5,
};

export const buttonFontWeight = {
	[ButtonHeight.Height20]: 700,
	[ButtonHeight.Height30]: 500,
	[ButtonHeight.Height40]: 500,
	[ButtonHeight.Height50]: 500,
	[ButtonHeight.Height60]: 500,
};

export enum ButtonBorderRadius {
	Radius5 = 5,
	Radius10 = 10,
	Radius6 = 6,
}

export interface IButtonProps {
	color: ButtonColors;
	height: ButtonHeight;
	borderRadius?: ButtonBorderRadius;
	onMouseEnter?: React.MouseEventHandler<HTMLButtonElement>;
	mute?: boolean;
	noBorder?: boolean;
	noInvertImage?: boolean;
	square?: boolean;
	hover?: boolean;
	hoverCurrencyColor?: string;
}
